/* ==========================================================
   MOHR PRODUCT
   Base Initialization
========================================================== */

(function () {
  'use strict';

  if (!window.mohrProductData) {
    console.error('Mohr Product Data not found.');
    return;
  }

  const data = window.mohrProductData;

  let selectedVariantId = data.variantId;
  let selectedPrice = Number(data.price);
  let embossingAddOn = 0;

  const EMBOSSING_PRICE = 650000;
  const EMBOSSING_VARIANT_ID = data.embossingVariantId;
  const MONEY_FORMAT = data.moneyFormat;

  function $(selector) {
    return document.querySelector(selector);
  }

  function $all(selector) {
    return document.querySelectorAll(selector);
  }

  function formatMoney(cents) {

    let value = (Number(cents) / 100).toFixed(2);

    let parts = value.split(".");

    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");

    return MONEY_FORMAT.replace(/\{\{\s*amount\s*\}\}/, parts.join("."));
  }

  window.Mohr = {
    data,
    formatMoney,
    getSelectedVariant() {
      return selectedVariantId;
    },
    getSelectedPrice() {
      return selectedPrice;
    },
    setVariant(id, price) {
      selectedVariantId = id;
      selectedPrice = Number(price);
    },
    setEmbossing(value) {
      embossingAddOn = value;
    },
    getEmbossing() {
      return embossingAddOn;
    },
    EMBOSSING_PRICE,
    EMBOSSING_VARIANT_ID
  };

})();